// @flow
import { Skeleton, Text, View } from 'reshaped';

export function ContactBlockPlaceholder(): React.MixedElement {
  return (
    <View gap={3} width="100%" overflow="hidden" shrink>
      <View gap={3} grow direction="row">
        <Skeleton width="18ch" />
        <Skeleton width="8ch" />
      </View>
      <View gap={2}>
        <Text>
          <Skeleton width="23ch" />
        </Text>
        <Text>
          <Skeleton width="20ch" />
        </Text>
        <Text>
          <Skeleton width="38ch" />
        </Text>
      </View>
    </View>
  );
}
